import React from 'react'
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import CreditContent from './creditscontent/creditsContent';
// import DocumentUploadContent from "./uploadcontent/documentuploadcontent";
import Footer from "../../components/footer";

const credits = () => {
  return (
    <div className="main">
    <Header />
    <InnerHeader title="Credits " />
    <CreditContent />
    <Footer />
    </div>
  )
}

export default credits